export default __webpack_public_path__ + "static/media/medical-team.80c0a096.png";